var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('Loader',{attrs:{"is-visible":_vm.loading}}),_c('StatsAttributionFilters',{attrs:{"commercials":_vm.commercials,"default":_vm.defaultFilters},on:{"apply":_vm.applyFilters}}),_c('StatsAttributionTable',{attrs:{"commercials-attributions":_vm.commercialsAttributions,"end-date":_vm.filters.end}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }